export default {
    ADMIN_WAARNEMINGEN_VAN_WAARNEMER:"AdminWaarnemingenVanWaarnemer",
    ADMIN_WIJZIG_DATA_WAARNEMER:'adminWijzigDataWaarnemer',
    BERICHT_VERZENDEN:'berichtVerzenden',
    DEVELOP_TOOLS:'developtools',
    GDPR:'gdpr',
    KALENDER: 'kalender',
    MAANDRAPPORT:'MaandRapport',
    RAPPORTEN:'Rapporten',
    WAARNEMER_MAAND:'WaarnemingenMaand',
    WAARNEMERS_OVERZICHT:'WaarnemersOverzicht',
    WAARNEMING_TOEVOEGEN: 'WaarnemingToevoegen',
    WAARNEMING_VAN_DAG: 'WaarnemingVanDag',
    WAARNEMINGEN_EXCEL_UPLOADEN:'WaarnemingenExcelUploaden',
    WAARNEMINGEN_WAARNEMER_FORM: 'WaarnemingenWaarnemerForm',
    WAARNEMINGEN_WAARNEMER_POOLFAKKEL:'WaarnemingenWaarnemerPoolfakkel',
    WAARNEMINGEN_WAARNEMER_POOLFAKKEL_GRAFIEK:'WaarnemingenWaarnemerWolfPoolfakkelGrafiek',
    WAARNEMINGEN_WAARNEMER_WOLF: 'WaarnemingenWaarnemerWolf',
    WAARNEMINGEN_WAARNEMER_WOLF_GRAFIEK:'waarnemingenWaarnemerWolfGrafiek',
    WAARNEMINGEN_WAARNEMER_BECK: 'WaarnemingenWaarnemerBeck',
    WAARNEMINGEN_WAARNEMER_BECK_GRAFIEK:'waarnemingenWaarnemerBeckGrafiek',
    WAARNEMINGEN_WAARNEMER_CV: 'WaarnemingenWaarnemerCV',
    WAARNEMINGEN_WAARNEMER_SN:'WaarnemingenWaarnemerSN',
    WAARNEMINGEN_WAARNEMER_SN_GRAFIEK:'WaarnemingenWaarnemerSNGrafiek',
    WAARNEMINGEN_WAARNEMER_IS:'WaarnemingenWaarnemerIS',
    WAARNEMINGEN_WAARNEMER_IS_GRAFIEK:'WaarnemingenWaarnemerISGrafiek',
    WAARNEMINGEN_WAARNEMER_CV_GRAFIEK:'waarnemingenWaarnemerCVGrafiek',
    GEGEVENS_WAARNEMER_SELECTIE:'gegevensWaarnemerSelectie',
    GEGEVENS_WAARNEMER_EDIT_WAARNEMER:'gegevensWaarnemerEditWaarnemer',
    GEGEVENS_WAARNEMER_EDIT_TELESCOOP:"gegevensWaarnemerEditTelescoop",
    LOGIN: 'Login',
    PARAMETERS_OVERZICHT:"parametersOverzicht",
    REGISTRATIE_FORMULIER:"registratieFormulier",
}